export const ENDPOINTS_EXCLUDED_FROM_LOADING = ['/admin/api/Roles']
